import { render, staticRenderFns } from "./QuestionAnswers.vue?vue&type=template&id=3d2400ee&scoped=true&lang=pug&"
import script from "./QuestionAnswers.vue?vue&type=script&lang=ts&"
export * from "./QuestionAnswers.vue?vue&type=script&lang=ts&"
import style0 from "./QuestionAnswers.vue?vue&type=style&index=0&id=3d2400ee&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2400ee",
  null
  
)

component.options.__file = "QuestionAnswers.vue"
export default component.exports